import { Ratings } from "@/api/AppApi/services/home/interfaces/IProduct";
import ReviewsRatio from "./ReviewsRatio";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  total: number;
  ratings: Ratings;
}

const RateDetails: React.FC<Props> = ({ total, ratings }) => {
  const t = useTranslation();
  const reviews = (
    (!!ratings ? Object.keys(ratings) : []) as Array<keyof Ratings>
  ).map((k: keyof Ratings) => ({
    name: t[k],
    count: ratings[k],
  }));
  return (
    <div className="reviews-table text-nowrap">
      <table>
        <tbody>
          {reviews?.map((review, key) => (
            <ReviewsRatio
              key={key}
              title={review.name}
              value={review.count}
              total={total}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RateDetails;
